var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.645 16.968-7.742-4.355L15.645 1l7.742 11.613-7.742 4.355zm0-2.22-4.973-2.799 4.973-7.46 4.974 7.46-4.975 2.797zM5 20.354c0-2.317.74-4.46 1.997-6.208l8.648 4.756 8.649-4.756a10.597 10.597 0 0 1 1.996 6.208C26.29 26.235 21.524 31 15.645 31 9.765 31 5 26.234 5 20.355z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdo);
export default __webpack_public_path__ + "static/media/LDO.bbee8ecb580868f9caada0afe82aafa4.svg";
export { ForwardRef as ReactComponent };